import moment from "moment";

export function dateNumberToAmericanTime(date){
    return moment(date).format("MM/DD/YYYY hh:mm A")
}
export function dateNumberToAmericanTimeSimple(date){
    return moment(date).format("MM/DD/YYYY")
}